import * as React from 'react'

export interface CheckboxProps extends Omit<
  React.InputHTMLAttributes<HTMLInputElement>,
  'value'
> {
  label: string
  value?: boolean
}

const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
  ({ label, name, value, ...props }, ref) => {
    return (
      <div className="flex">
        <div className="flex h-5 items-center">
          <input
            name={name}
            aria-describedby="helper-checkbox-text"
            type="checkbox"
            className="h-4 w-4 rounded border-gray-300 bg-gray-100 text-blue-600 focus:ring-2 focus:ring-blue-500 dark:border-gray-600 dark:bg-gray-700 dark:ring-offset-gray-800 dark:focus:ring-blue-600"
            ref={ref}
            checked={value}
            {...props}
            id={name}
          />
        </div>
        <div className="ms-2 text-sm">
          <label
            htmlFor={name}
            className="font-medium text-gray-900 dark:text-gray-300"
          >
            {label}
          </label>
        </div>
      </div>
    )
  },
)

Checkbox.displayName = 'Checkbox'

export { Checkbox }
